import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { IPropertySearchCriteria } from '../../../shared/models/propertysearchcriteria';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { PropertyListingBase } from '../../../property-listing/property-listing-base';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { IPortfolioPropertySuggestOutputModel } from '../../../shared/models/SavePropertyInputModel';
import { CommonService } from '../../../shared/providers/common.service';
import { LookUp } from '../../../shared/enum/enum';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { ToastService } from '../../../shared/providers/toast.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { SharedService } from '../../../shared/providers/shared.service';
import {
  catchError,
  distinctUntilChanged,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-portfolio-property-suggest',
  templateUrl: './portfolio-property-suggest.component.html',
  styleUrls: ['./portfolio-property-suggest.component.css'],
})
export class PortfolioPropertySuggestComponent
  extends PropertyListingBase
  implements OnInit
{
  @Input() suggested = [];
  @Output() close = new EventEmitter();
  @Output() selectedProperties = new EventEmitter();
  @ViewChildren(MatSelect) matSelects: QueryList<MatSelect>;
  @Input() propertyId: number;
  @Input() showOnlyZCF?: boolean;
  @Input() statusId: number;
  @Input() propertyStatusId: number;
  @Input() isDataEntryProperty: boolean = false;
  @Input() includeBOV: boolean = false;
  searchCriteria = {} as IPropertySearchCriteria;
  filterStateId = null;
  dtOptions = {};
  propertySuggestList: IPortfolioPropertySuggestOutputModel[];
  inputAssetTypes = [];
  inputPropertyStatus = [];
  inputRatings = [];
  inputTenants = [];
  inputTerms = [];
  //defaultTypeText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Property Type'
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: 'Property Type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };

  //defaultStatusText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Property Status'
  //};
  defaultStatusSettings = {
    singleSelection: false,
    text: 'Property Status',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };

  //defaultTenantText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Tenant Trade',
  //    searchEmptyResult: 'No results found...',
  //};
  defaultTenantSettings = {
    enableSearch: true,
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    buttonClasses: 'btn btn-default btn-block',
  };
  //defaultCreditText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Rating'
  //};
  defaultCreditSettings = {
    dynamicTitleMaxItems: 1,
  };
  //defaultTermText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Term'
  //};
  defaultTermSettings = {
    dynamicTitleMaxItems: 1,
  };
  LoggedInUser: any;
  suggestPropertyIds = [];
  propertyDataService: []; /*CompleterData;*/
  existingProperty: any = null;
  selectAllCheckbox = false;
  IsValid: boolean = false;
  @ViewChild('dropdownTenants') dropdownTenants: any;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  propertySelected;
  currentPoint: number;
  _takeCount = 20;
  isBackspaceActive = false as boolean;
  addressPreviousVal = '' as string;
  selectedData = [] as any[];

  constructor(
    private Authentication: AuthenticationService,
    protected http: HttpClient,
    protected _propertyListingService: PropertyListingService,
    private Loader: LoaderService,
    protected activatedRoute: ActivatedRoute,
    public _commonService: CommonService /*private completerService: CompleterService,*/,
    private Toast: ToastService,
    private _validationService: ValidationService,
    private _sharedService: SharedService,
    private router: Router,
    private _propertyManagementService: PropertyManagementService
  ) {
    super(
      _propertyListingService,
      http,
      Authentication,
      Loader,
      activatedRoute
    );
    /* this.activatedRoute.queryParams.subscribe((params: Params) => {*/
    //const propertyDataProvider = completerService.remote(null, 'PropertyName', 'PropertyName');
    //propertyDataProvider.urlFormater(x => {
    //    return encodeURI(this.BASE_URL + '/property/GetAddressByAutocomplete?searchText=' + encodeURIComponent(x) + '&userId=' + (this.user ? this.user.Id : 0) + '&typeId=' + 3);
    //});
    //propertyDataProvider.descriptionField('Type');

    //this.propertyDataService = propertyDataProvider;
    /* });*/
    this.loadItems();
  }

  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      tap(() => (this.loading = true)),
      switchMap((term) =>
        this.getItems(term).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => (this.loading = false))
        )
      )
    );
  }

  getItems(term: any = null): Observable<any[]> {
    var type = this._commonService.getSelectedComponent(this.router.url);
    return this._propertyManagementService.getOfferDetailsByPropertyId(
      term,
      this.user.Id,
      type
    );
  }

  ngOnInit() {
    this.LoggedInUser = this.Authentication.user;
    this.clearPropertyModel();
    this.defaultSearchCriteriaValues();
    this.searchCriteria.PropertyId = this.propertyId;

    // Loads the property type
    this._commonService.getTypeList().subscribe((response) => {
      this.inputAssetTypes = response.map((o) => {
        return { id: o.Id, name: o.Type };
      });
    });

    this._commonService
      .getLookupsByTypeId(LookUp.PropertyStatus)
      .subscribe((response) => {
        if (response != null && response.length > 0) {
          if (this.includeBOV) {
            this.inputPropertyStatus = response
              .map((o) => {
                return { id: o.Id, name: o.Description };
              })
              .filter((x) => x.id != 355 && x.id != 350);
          } else {
            this.inputPropertyStatus = response
              .map((o) => {
                return { id: o.Id, name: o.Description };
              })
              .filter((x) => x.id != 355 && x.id != 349 && x.id != 350);
          }
        }
      });

    this._commonService
      .getLookupsByTypeId(LookUp.Rating)
      .subscribe((response) => {
        if (response != null && response.length > 0) {
          response = response.filter((x) => x.IsActive == true);
          this.inputRatings = response.map((o) => {
            return { id: o.Id, name: o.Description };
          });
        }
      });

    //this._propertyListingService.getTenants().subscribe(response => {
    //    if (response != null && response.length > 0) {
    //        this.inputTenants = response.map(o => { return { id: o.Id, name: o.TradeName }; });
    //    }
    //});

    this._propertyListingService.getTerms().subscribe((response) => {
      if (response != null && response.length > 0) {
        this.inputTerms = response.map((o) => {
          return { id: o.Id, name: o.Term };
        });
      }
    });
  }

  clearAllSelections() {
    this.matSelects.toArray().forEach(select => {
      select.value = null;  // Clear the value of each MatSelect
    });
  }

  IsLoading = false;
  loadProperties() {
    this.user = this.authService.user;
    this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
    if (
      this.searchCriteria.StateId != null &&
      this.searchCriteria.StateId != undefined &&
      typeof this.searchCriteria.StateId === 'number'
    ) {
      this.filterStateId = this.searchCriteria.StateId;
    }
    //} else if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'object') {
    //  this.filterStateId = this.searchCriteria.StateId?.[0];
    //}
    this.searchCriteria.PropertyFor = 602;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      pageLength: 50,
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = this.searchCriteria;
        this.IsLoading = true;
        dataTablesParameters.Extra_param.PropertyFor = this.statusId;
        dataTablesParameters.Extra_param.ShowOnlyZCF = this.showOnlyZCF
          ? true
          : false;
        dataTablesParameters.Extra_param.IsDataEntryProperty =
          this.isDataEntryProperty;
        dataTablesParameters.Extra_param.IncludeBOV = this.includeBOV;
        dataTablesParameters.Extra_param.StatusId = this.propertyStatusId;

        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/propertieslistviewforportfolio',
            dataTablesParameters,
            {}
          )
          .subscribe((resp) => {
            this.propertySuggestList = resp ? (resp.data ? resp.data : []) : [];
            this.searchCriteria.SortValue = '';
            that.propertySuggestList.forEach((data) => {
              if (that.suggestPropertyIds.includes(data.Id)) {
                data.IsChecked = true;
              }
            });

            if (resp.data.length === 0) {
              $('.dataTables_paginate.paging_full_numbers').hide();
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: [],
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            }
            this.IsLoading = false;
            $('.paginate_button.first,.paginate_button.last').hide();
          });
      },
      columnDefs: [
        { orderable: false, targets: 0 },
        { orderable: false, targets: 1 },
      ],
      columns: [
        { data: 'Guid' },
        { data: 'OMFilePath' },
        { data: 'PropertyName' },
        { data: 'State' },
        { data: 'PropertyForId' },
        { data: 'AssetType' },
        { data: 'PropertyStatus' },
        { data: 'Price' },
        { data: 'RentNOI' },
        { data: 'CreditRating' },
        { data: 'CapRate' },
        { data: 'RemainingTerm' },
        { data: 'LeaseStructure' },
        { data: 'BuildingSize' },
      ],
    };
  }

  clearPropertyModel() {
    this.propertySelected = [];
    this.loadProperties();
  }

  defaultSearchCriteriaValues() {
    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 20;
    this.searchCriteria.Address = '';
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PropertyStatus = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Ratings = [];
    this.searchCriteria.Terms = [];
    this.searchCriteria.SortValue = 'PLH';
    this.searchCriteria.IsSearchButtonClicked = false;
    this.searchCriteria.MinTerm = null;
    this.searchCriteria.MaxTerm = null;
  }
  validateFilters() {
    if (this.IsValid == true) {
      this.searchInformationValidation();
    }
  }

  onChecked(data) {
    if (data.IsChecked) {
      this.existingProperty = this.suggested.filter((x) => x == data.Id)[0];
      if (this.existingProperty != null && this.existingProperty != undefined) {
        this.propertySuggestList.find((x) => x.Id == data.Id).IsChecked = false;
        this.propertySuggestList.find(
          (x) => x.Id == data.Id
        ).DisabledSelection = true;
        this.Toast.addToast({
          title: 'Error Occurred',
          msg: data.PropertyName + ' is already exists in suggested list',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else if (
        data.PortfolioPropertyId != null &&
        data.PortfolioPropertyId > 0 &&
        data.PortfolioPropertyId != this.propertyId
      ) {
        this.propertySuggestList.find((x) => x.Id == data.Id).IsChecked = false;
        this.propertySuggestList.find(
          (x) => x.Id == data.Id
        ).DisabledSelection = true;
        this.Toast.addToast({
          title: 'Error Occurred',
          msg: 'This Property already exist in. Please select another property.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else {
        this.suggestPropertyIds.push(data.Id);
        this.selectedData.push(data);
      }
    } else {
      const index: number = this.suggestPropertyIds.indexOf(data.Id);
      if (index !== -1) {
        this.suggestPropertyIds.splice(index, 1);
        this.selectedData.splice(index, 1);
      }
    }

    let checkedCount = 0;
    this.propertySuggestList.forEach((item) => {
      if (item.IsChecked) {
        checkedCount++;
      }
    });
    if (checkedCount === this.propertySuggestList.length) {
      this.selectAllCheckbox = true;
    } else {
      this.selectAllCheckbox = false;
    }
  }

  onClose($event) {
    this.suggestPropertyIds = [];
    this.close.emit(true);
  }

  onPropertySearch() {
    this.searchInformationValidation();
    if (this.IsValid == true) {
      this.propertySearchCriteria(this.searchCriteria);
    } else {
      return false;
    }
  }

  onResetClick() {
    var input = $('.search-field-input');
    input.each(function (item) {
      $(input[item]).val('');
    });
    this.dataServiceInput$.next('');
    this.clearAllSelections();
    // if (this.dropdownTenants != undefined && this.dropdownTenants != null) {
    //   this.dropdownTenants.clearSearch();
    // }
    this.defaultSearchCriteriaValues();
    this.onPropertySearch();
  }

  searchInformationValidation() {
    this.IsValid = true;
    if (
      this._validationService.IsNull(this.searchCriteria.PriceFrom) != '' &&
      this._validationService.IsNull(this.searchCriteria.PriceTo) != '' &&
      Number(this.searchCriteria.PriceFrom) >
        Number(this.searchCriteria.PriceTo)
    ) {
      this.IsValid = false;
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Price To should be greater than Price From',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
    if (
      this._validationService.IsNull(this.searchCriteria.MinTerm) != '' &&
      this._validationService.IsNull(this.searchCriteria.MaxTerm) != '' &&
      Number(this.searchCriteria.MinTerm) > Number(this.searchCriteria.MaxTerm)
    ) {
      this.IsValid = false;
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Max Term should be greater than Min Term',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.onPropertySearch();
    } else if (event.key === 'Backspace' && event.key === 'Delete') {
      this.isBackspaceActive = true;
    }
  }

  onKeyUp(event) {
    if (
      this.searchCriteria.Address.length == 0 &&
      this.isBackspaceActive &&
      this.addressPreviousVal.length > 0
    ) {
      this.onPropertySearch();
      this.isBackspaceActive = false;
    }

    this.addressPreviousVal = this.searchCriteria.Address;
  }

  onPropertyAutocompleteSelect($event) {
    if ($event != null) {
      this.searchCriteria.Address = $event.PropertyName;
      this.searchCriteria.AddressTypeId = $event.Id;
      this.searchCriteria.AddressType = $event.AddressTypeID;
      this.searchCriteria.AddressTypeName = $event.Type;
      this.isBackspaceActive = true;
      this.onPropertySearch();
    } else {
      this.searchCriteria.AddressTypeId = 0;
      this.searchCriteria.AddressType = 0;
      this.searchCriteria.AddressTypeName = null;
    }
  }
  onInputKeyPress(event) {
    if (event.key === 'Enter') {
      this.onPropertySearch();
    }
  }

  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    this.currentPoint = 0;
    this.searchCriteria = searchParameters;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: this._takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: this.searchCriteria.IsMapView,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.filterStateId,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: this.searchCriteria.IsComp,
      IsArchive: this.searchCriteria.IsArchive,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
    };
    this.searchCriteria = searchCriteria;
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  onAdd(event) {
    if (this.suggestPropertyIds.length == 0) {
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least one property to suggest',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.selectedProperties.emit(this.selectedData);
      this.onClose(event);
      this.suggestPropertyIds = [];
    }
  }

  compareById(item1: any, item2: any): boolean {
    return item1?.Id === item2?.Id;
  }
  displayFn(item: any): string {
    return item ? (item.PropertyName != null && item.PropertyName != undefined) ? item.PropertyName : item : '';
  }
  
  trackByIndex(index: number, item: any): number {
    return index;
  }
}
